import api from '../../api';

const listFilters = async () =>
    api.get({ service: `marketing/whatsapp/campaign/filter/list-filters` });

const findFilterOptionsByKey = async (filterName) =>
    api.get({ service: `marketing/whatsapp/campaign/filter/filter-options/${filterName}` });

export const createCampaign = async (campaign) =>
    api.post({
        type: "user",
        service: `marketing/whatsapp/campaign`,
        data: campaign
    }).then(res => res.data);

export const findAllCampaigns = async (filters = {}, pagination, sortConfig) => {

    const filter = buildRequestFilter(filters);

    return await api.post({
        type: "user",
        service: `marketing/whatsapp/campaign/filter`,
        data: { filter, pagination, sortConfig },
    }).then(res => res.data);
}

export const findMetrics = async (filters = {}, pagination) => {

    const filter = buildRequestFilter(filters);

    return await api.post({
        type: "user",
        service: `marketing/whatsapp/campaign/metrics`,
        data: { filter, pagination },
    }).then(res => res.data || {});
}

export const findSalesMetrics = async (filters = {}, pagination) => {

    const filter = buildRequestFilter(filters);

    return await api
        .post({ service: `marketing/whatsapp/campaign/sales-metrics`, data: { filter, pagination } })
        .then(res => res.data || {});
}

export const findProductSalesMetrics = async (filters = {}, pagination) => {

    const filter = buildRequestFilter(filters);

    return await api
        .post({ service: `marketing/whatsapp/campaign/product-sales-metrics`, data: { filter, pagination } })
        .then(res => res.data || {});
}

export const findSalesByHoursMetrics = async (filters = {}, pagination) => {

    const filter = buildRequestFilter(filters);

    return await api
        .post({ service: `marketing/whatsapp/campaign/sales-by-hours-metrics`, data: { filter, pagination } })
        .then(res => res.data || {});
}

export const findCampaignSettings = async (campaignId) => {
    return await api
        .get({ service: `marketing/whatsapp/campaign/${campaignId}/settings` })
        .then(res => res.data || {});
}

const setWhatsappCampaignFilterInLocalStorage = (filters) => {
    localStorage.setItem('@facilita-app/whatsapp-campaign-filters', JSON.stringify(filters));
}

const getWhatsappCampaignFilterInLocalStorage = () => {
    const data = localStorage.getItem('@facilita-app/whatsapp-campaign-filters');
    return data ? JSON.parse(data) : null;
}

export const buildRequestFilter = (filters) => {
    const filter = Object.entries(filters).map(([key, value]) => {

        let parsedValue = value;

        if (value && typeof value === "object" && "value" in value) {

            if (key == "period") {
                return {
                    name: key,
                    value: [
                        value?.customValue?.startDate || value.value[0],
                        value?.customValue?.endDate || value.value[1]
                    ],
                    previousPeriod: [
                        value?.previousPeriod?.value[0],
                        value?.previousPeriod?.value[1]
                    ]
                };
            }
            parsedValue = value.value;
        }

        return { name: key, value: parsedValue };
    });

    return filter.filter(f =>
        (Array.isArray(f.value) &&
            f.value.length &&
            f.value.every(v => !!v)
        ) ||
        (!Array.isArray(f.value) &&
            f.value !== null &&
            f.value !== undefined
        )
    );
};

const WhatsappCampaignService = {
    listFilters,
    findFilterOptionsByKey,
    createCampaign,
    findAllCampaigns,
    findMetrics,
    findSalesMetrics,
    findProductSalesMetrics,
    findSalesByHoursMetrics,
    findCampaignSettings,
    setWhatsappCampaignFilterInLocalStorage,
    getWhatsappCampaignFilterInLocalStorage
}

export default WhatsappCampaignService;